import { API } from 'aws-amplify';

export function getLicense(queryStringParameters:any)
{
	return API.get('userManagement', '/getLicense', { queryStringParameters });
}
export function sendRequest(body:any)
{
	return API.post('analytics', '/license', { body });
}
export function getContactLS()
{
	return API.get('analytics', '/getContact', {});
}